import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { BRAND } from "@/lib/api";
import Wordmark from "./Wordmark";

/**
 * AnimatedLogo — clean icon mark + optional typed wordmark.
 *
 *   size          -> Tailwind height utility for the icon, e.g. 'h-12 md:h-14'
 *   to            -> if provided wraps in a router Link (pass null to skip)
 *   withWordmark  -> render the typed ALLTASK / MOVES wordmark beside the icon
 *   inverse       -> wordmark in white (for dark backgrounds)
 */
export const AnimatedLogo = ({
    size = "h-12 md:h-14",
    to = "/",
    className = "",
    withWordmark = false,
    inverse = false,
    "data-testid": testId = "brand-logo",
}) => {
    const inner = (
        <motion.span
            initial={{ opacity: 0, y: -4 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            whileHover={{ scale: 1.04 }}
            className={`group inline-flex items-center gap-2 md:gap-3 ${className}`}
            data-testid={testId}
        >
            <motion.img
                src={BRAND.logo}
                alt="AllTask Moves"
                draggable={false}
                className={`${size} w-auto select-none transition-transform duration-500 group-hover:rotate-[-4deg]`}
                animate={{ y: [0, -2, 0] }}
                transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
            />
            {withWordmark && (
                <Wordmark
                    primarySize="text-lg md:text-xl"
                    secondarySize="text-[10px] md:text-xs"
                    inverse={inverse}
                />
            )}
        </motion.span>
    );

    if (!to) return inner;
    return (
        <Link to={to} className="inline-flex items-center">
            {inner}
        </Link>
    );
};

export default AnimatedLogo;
